import { LuMonitor, LuSmartphone, LuTablet } from "react-icons/lu";
import {
  DashboardMode,
  useDashboardControlsActions,
} from "../../../view_stores/useDashboardControlsStore";
import {
  PreviewMode,
  useProjectPreviewActions,
  useProjectPreviewMode,
} from "../../../view_stores/useProjectPreviewStore";

export function ProjectPreviewControls() {
  return (
    <div
      className="flex items-center justify-center gap-4 p-2
    bg-[#F2F3FD] dark:bg-[#1E2023] rounded-lg"
    >
      <OrientationControls />
    </div>
  );
}

function OrientationControls() {
  const { setDashboardMode } = useDashboardControlsActions();
  const previewMode = useProjectPreviewMode();
  const { setPreviewMode } = useProjectPreviewActions();

  function onOrientationChange(orientation: PreviewMode) {
    setDashboardMode(DashboardMode.PREVIEW);
    setPreviewMode(orientation);
  }

  return (
    <div className="flex items-center gap-1">
      <OrientationBtn
        icon={<LuMonitor size={16} />}
        title="Desktop"
        onClick={() => onOrientationChange(PreviewMode.Desktop)}
        isSelected={previewMode === PreviewMode.Desktop}
      />
      <OrientationBtn
        icon={<LuSmartphone size={16} />}
        title="Mobile Portrait"
        onClick={() => onOrientationChange(PreviewMode.MobilePortrait)}
        isSelected={previewMode === PreviewMode.MobilePortrait}
      />
      <OrientationBtn
        icon={<LuSmartphone size={16} className="rotate-90" />}
        title="Mobile Landscape"
        onClick={() => onOrientationChange(PreviewMode.MobileLandscape)}
        isSelected={previewMode === PreviewMode.MobileLandscape}
      />
      <OrientationBtn
        icon={<LuTablet size={16} />}
        title="Tablet"
        isSelected={previewMode === PreviewMode.Tablet}
        onClick={() => onOrientationChange(PreviewMode.Tablet)}
      />
    </div>
  );
}

function OrientationBtn({
  icon,
  title,
  isSelected,
  onClick,
}: {
  icon: React.ReactNode;
  title: string;
  isSelected: boolean;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={`p-2 rounded-md transition-colors ${
        isSelected
          ? "text-light-text dark:text-dark-text bg-white dark:bg-[#272829]"
          : "text-light-text dark:text-dark-text hover:bg-white dark:hover:bg-[#272829]"
      }`}
      title={title}
    >
      {icon}
    </button>
  );
}
